module.exports = __webpack_public_path__ + "assets/img/DS-room3 (6).1d6e7ed5.jpg";